var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "margin-top" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                { staticClass: "container-right" },
                [
                  _c("app-display", {
                    class: "text",
                    attrs: {
                      label: "Nome da gleba:",
                      content: _vm.cadastroGleba.nome
                    }
                  }),
                  _c("app-display", {
                    class: "text",
                    attrs: {
                      label: "Data de cadastro:",
                      content: _vm.formatarData(_vm.cadastroGleba.dataCadastro)
                    }
                  })
                ],
                1
              ),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Município da gleba:",
                  content: _vm.cadastroGleba.nomeMunicipiosGleba
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Área total (ha):",
                  content: _vm.formatarArea(_vm.cadastroGleba.areaTotal)
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Áreas remanescentes (ha):",
                  content: _vm.formatarArea(_vm.cadastroGleba.areaRemanescente)
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Cartório:",
                  content: _vm.cadastroGleba.nomeCartorio
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Município do cartório:",
                  content: _vm.cadastroGleba.nomeMunicipioCartorio
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Matrícula:",
                  content: _vm.cadastroGleba.matricula
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Data de matrícula:",
                  content: _vm.formatarData(_vm.cadastroGleba.dataMatricula)
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: { label: "Livro:", content: _vm.cadastroGleba.livro }
              }),
              _c("app-display", {
                class: "text",
                attrs: { label: "Folha:", content: _vm.cadastroGleba.folha }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Latitude:",
                  content: _vm.cadastroGleba.latitude || "-"
                }
              }),
              _c("app-display", {
                class: "text",
                attrs: {
                  label: "Longitude:",
                  content: _vm.cadastroGleba.longitude || "-"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e8616a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8616a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/bancoDados/components/InformacoesCadastro.vue
// module id = null
// module chunks = 